<header>
  <mat-toolbar class="mat-elevation-z2">
    <mat-toolbar-row class="toolbar-logo-row">
      <div class="shell-container-row toolbar-row-content">
        <app-user-logo [isSmall]="(isSmall | async)!" [name]="user.name" [thumbnailPhoto]="user.thumbnailPhoto"
          [matMenuTriggerFor]="menu" />
        <app-company-logo *ngIf="1" [isSmall]="(isSmall | async)!" />
      </div>
    </mat-toolbar-row>
    <mat-toolbar-row class="toolbar-action-row">
      <div class="shell-container-row toolbar-row-content">
        <app-overview-link *ngIf="showOverviewButton" [isSmall]="(isSmall | async)!" />
        <app-portal-administration-link *appShowAuthorize="'PORTAL_ADMIN'" [isSmall]="(isSmall | async)!" />
        <app-home-link *ngIf="isCustomerSpace && customerSpaceId" [name]="customerSpaceName"
          [customerSpaceId]="customerSpaceId" />
        <!-- For demonstration -->
        <app-notification-button *ngIf="false" [notificationCount]="4" (onclick)="showNotifications($event)" />
        <app-notification-button *ngIf="isCustomerSpace && (isAuthorized() | async)"
          [notificationCount]="(notificationCount$ | async)!" (onclick)="showNotifications($event)" />
        <ng-container *ngIf="isCustomerSpace && customerSpaceId">
          <app-customer-space-administration-link
            *appShowAuthorize="'CUSTOMER_SPACE_WRITE'; options: { values: { customerSpaceId: customerSpaceId } }"
            [customerSpaceId]="customerSpaceId" />
        </ng-container>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-menu #menu="matMenu" xPosition="after">
    <a mat-menu-item [routerLink]="['/', 'user-profile']">
      <mat-icon svgIcon="settings_icon" class="settings-icon"></mat-icon>
      <span>{{ 'header.profile-menu.profile' | translate }}</span>
    </a>
    <a *ngIf="isCustomerSpace" mat-menu-item [routerLink]="['/', 'customer-spaces', this.customerSpaceId, 'contacts']">
      <mat-icon svgIcon="contacts_icon" class="contacts-icon"></mat-icon>
      <span>{{ 'header.toolbar.contacts' | translate }}</span>
    </a>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon svgIcon="logout_icon" class="logout-icon"></mat-icon>
      <span>{{ 'header.profile-menu.logout' | translate }}</span>
    </button>
  </mat-menu>
</header>